import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SessionContext from '../../../../library/Core/SessionContext';
import SendMessage from './SendMessage';
import { axiosClient } from '../../../../library/Service/axiosClient';
import { handleCopyText } from '../../../../library/Core/SmartFunctions';
import { SmartContext } from '../../../../library/Core/SmartContext';

function CounsellingSessions() {
    const { id, pageName } = useParams();

    const { sessionState }: any = useContext(SessionContext);
    const { state, dispatch } = useContext(SmartContext);
    const [usersessions, setUserSessions] = useState([]);
    const isCounsellor = sessionState?.isCounsellor == true ? 1 : 0;
    const isUserActive = state?.data?.userInstitutes?.every(
      (val: any) => val.userTypeCode !== 'STUDENT' || val.userStatusCode === 'ACTIVE'
    );

    const isUserStudent = state?.data?.userInstitutes?.every(
      (val: any) => val.userTypeCode != 'ALUMNI'
    );

    console.log(state?.data, 'data at 23')
    useEffect(() => {
        if (!id) return;
    
        const fetchPreferenceData = async () => {
            try {
                const response = await axiosClient().get(
                    `${process.env.REACT_APP_BAS_API}/counsellorsession/user-session/${id}`
                );

                const result = response.data?.data;

                console.log(response.data, 'data at 24')

                setUserSessions(response.data?.data || []);

            } catch (error) {
                console.error("Error fetching preference data:", error);
            }
        };

        fetchPreferenceData();
    }, [id]);

    const handleStatusUpdate = async (id : any, status : any) => {
      try {

        const response = await axiosClient().post(
            `${process.env.REACT_APP_BAS_API}/counsellorsession/session-status-update`, {id, status});
        const res = await response.data;
        
        if (res.success === false) {
          alert(res.message);
          window.location.reload();  // Refresh the page
          
        } else {
          alert(`Session marked as ${status}`);
          window.location.reload();  // Refresh the page
        }
        // const response = await fetch('/api/update-status', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({ id, status }),
        // });
    
        // if (response.success) {
        //   alert(`Session marked as ${status}`);
        //   // Optionally reload or refetch data
        // } else {
        //   alert('Failed to update status.');
        // }
      } catch (error) {
        console.error('Error updating status:', error);
      }
    };
    

    const formatDateTime = (dateStr: string) => {
      const date = new Date(new Date(dateStr).getTime() + 330 * 60000); // Convert to IST manually
    
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear();
    
      const time = date.toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    
      return `${day}-${month}-${year} ${time}`;
    };

      const bookingUrl = `${process.env.REACT_APP_APP_BASE_URL}/sso/${state?.data?.userInstitutes[0]?.userHash}/YmFz`;

      const handleCopy = () => {
        navigator.clipboard.writeText(bookingUrl)
          .then(() => {
            alert('Link copied to clipboard!');
          })
          .catch((err) => {
            console.error('Failed to copy: ', err);
          });
      };
      const handleCopyList = (text: string) => {
        navigator.clipboard.writeText(text)
          .then(() => {
            // Optional: Use a toast or alert
            alert('Link copied to clipboard!');
          })
          .catch((err) => {
            console.error('Failed to copy: ', err);
          });
      };
  return (
    <>
    <div>
            <div className="counselling-lists">
                <div className="tab-white-block mb-2 p-0 overflow-hidden border">
                    {/* {canEditProfile(model.id, sessionState) && (
                        <a className="pencil-edit" role="button" onClick={() => navigate(`/alumni/${id}/profile-picture`)}></a>
                    )} */}
                    <div className="d-flex flex-wrap flex-column flex-md-row">
                        <div className="nav flex-row flex-md-column nav-pills custom-sub-tab ps-3 py-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <Link className="nav-link" to={`/alumni/${id}/profile/counselling`}>Psychometric Tests </Link>
                            <Link className="nav-link active" to={`/alumni/${id}/profile/sessions`}>Sessions</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/counselling-logs`}>Counselling Logs</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/communication-logs`} >Communication Logs</Link>
                            <Link className="nav-link" to={`/alumni/${id}/profile/counsellor-notes`} >Counsellor Notes</Link>   
                        </div>
                        <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 width-cal-191" id="v-pills-tabContent">
                            
                            <div className="tab-pane fade active show" id="v-pills-sessions" role="tabpanel" aria-labelledby="v-pills-sessions-tab">
                            {isUserActive && isUserStudent && !state?.data?.basCloseCase && (
                              <div className='row g-2 align-items-center'>
                                <div className='col-sm'>
                                  <span className='font-18 font-500'>Student Booking Link</span>
                                  <div className='personalisedBookingLink d-flex align-items-center'>
                                    <a className='text-dark singleline-ellipsis' href={bookingUrl}>
                                      {bookingUrl}
                                    </a>
                                    <i
                                      className="bi bi-copy ms-2 cursor-pointer"
                                      onClick={handleCopy}
                                      title="Copy to clipboard"
                                      style={{ cursor: 'pointer' }}
                                    ></i>
                                  </div>
                                </div>
                                <div className='col-sm-auto'>
                                  <a
                                    className='btn btn-green'
                                    href={`${process.env.REACT_APP_APP_BASE_URL}/alumni/${id}/bas`}
                                  >
                                    <span>Admin Book Session</span>
                                  </a>
                                </div>
                              </div>
                            )}

                                <div className="table-responsive attendee_dtl pt-3">
                                    <table className="table lastTRLineRemove" style={{minWidth: 850}}>
                                        {/* <tbody>
                                            <tr>
                                                <td>
                                                    <div className="d-flex flex-column">                          
                                                        <span  className="font-18 lineHeight-16 font-500">CS2</span>
                                                        <span className="d-block font-14 font-400 text-gray-64">Ayushi vasu</span>
                                                    </div>
                                                </td>

                                                <td>
                                                        <div className="font-400"><span className="font-500">Conducted on - </span> 8-Nov-2024 </div>
                                                </td>
                                        
                                                <td className="text-start" width={350}>
                                                    <div className='row g-2'>
                                                        <div className='col-auto'><button className='btn btn-gray-de height-40'>View Summary</button></div>
                                                        <div className='col-auto'><SendMessage className='btn btn-gray-de height-40' btnText='SD'/></div>
                                                        <div className='col-auto'><button className='btn btn-border'>View Recording</button></div>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <div className="d-flex flex-column">                          
                                                        <span  className="font-18 lineHeight-16 font-500">CS1</span>
                                                        <span className="d-block font-14 font-400 text-gray-64">Vidhi Jain</span>
                                                    </div>
                                                </td>

                                                <td>
                                                        <div className="font-400"><span className="font-500">Booked For-  </span> 7-Nov-2024 </div>
                                                </td>
                                        
                                                <td className="text-start" width={350}>
                                                    <div className='row g-2'>
                                                        <div className='col-auto'><button className='btn btn-border'>Session Link</button></div>
                                                    </div>
                                                </td>
                                            </tr>

                                                    

                                        </tbody> */}

<tbody>
  {usersessions.length === 0 ? (
    <tr>
      <td colSpan={3} className="text-center py-4 text-muted">
        No session has been booked.
      </td>
    </tr>
  ) : (
    usersessions.map((userdata: any, index: number) => {
      const appointmentFromIST = new Date(new Date(userdata?.appointment_from).getTime() + 330 * 60000);
      const fullName = [userdata.first_name, userdata.last_name].filter(Boolean).join(' ').trim() || 'Unknown Counsellor';


      // const formatTime = (dateStr: string) => {
      //   const date = new Date(dateStr);
      //   return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      // };

      const formatTime = (dateStr: string) => {
        const date = new Date(new Date(dateStr).getTime() + 330 * 60000);
        return date.toLocaleTimeString('en-IN', {
          timeZone: 'Asia/Kolkata',
          hour: '2-digit',
          minute: '2-digit',
        });
      };

      const appointmentFrom = userdata.appointment_from
        ? formatDateTime(userdata.appointment_from)
        : 'N/A';

      const appointmentTo = userdata.appointment_to
        ? formatTime(userdata.appointment_to)
        : 'N/A';

        const shouldShowCompletedButton =
        (isCounsellor && ['SCHEDULED'].includes(userdata?.counselling_status) && (new Date(appointmentFromIST).getTime() < new Date().getTime()))

        const showReschedulebtn =
        (sessionState?.userTypeCode == 'SUPER_ADMIN' && ['SCHEDULED'].includes(userdata?.counselling_status) && ((new Date(appointmentFromIST).getTime() - new Date().getTime()) > 60 * 60 * 1000))

      
  //     const isSessionEnded =
  // userdata.appointment_to &&
  // new Date(userdata.appointment_to).getTime() < Date.now();

  const toIST = (date: Date | string) => {
    const d = new Date(date);
    return new Date(d.getTime() + 330 * 60000); // Convert UTC to IST
  };
  
  const appointmentToIST = toIST(userdata.appointment_to);
  const nowIST = toIST(new Date());
  
  const shouldShowMissedButton =
  (isCounsellor && ['SCHEDULED'].includes(userdata?.counselling_status) && (new Date(appointmentFromIST).getTime() < new Date().getTime()))
  
  const status = userdata?.counselling_status;

  const statusColorClass: Record<string, string> = {
    COMPLETED: 'text-green',
    SCHEDULED: 'text-student',
    'RE-SCHEDULED': 'text-dark-blue',
    'SD-SEND': 'text-dark-blue',
    MISSED: 'text-gray-41',
  };
  
  const statusClass = statusColorClass[status] || 'text-secondary'; // fallback class
  

      const appointmentLink = userdata.appointment_link
        ? userdata.appointment_link
        : 'N/A';

      return (
        <tr key={index}>
          <td>
            <div className="d-flex flex-column">
              <span className="font-18 lineHeight-16 font-500">{`CS${userdata.counselling_stage}`}</span>
              <span className="d-block font-14 font-400 text-gray-64">
                {fullName}
              </span>
            </div>
          </td>
          <td>
            <div className="font-400 max-300">
              <span className="font-500 d-block">Session timing</span>
              {appointmentFrom} to {appointmentTo}
              {userdata?.counselling_status === 'SCHEDULED' && (
              <div className="w-100 d-flex align-items-center">
                <a className="text-dark singleline-ellipsis copy-line" href={appointmentLink}>
                  {appointmentLink}
                </a>
                <i
                  className="bi bi-copy ms-2"
                  style={{ cursor: 'pointer' }}
                  title="Copy to clipboard"
                  onClick={() => handleCopyList(appointmentLink)}
                ></i>
              </div>
              )}
              <div className={`d-flex align-items-center rounded-pill font-14 font-500 ${statusClass}`}>
                {status}
              </div>
            </div>
          </td>

          <td className="text-start" width={350}>
            <div className="row g-2">

            {shouldShowCompletedButton ? (
              <div className="col-auto">
                <button
                  onClick={() => handleStatusUpdate(userdata.id, 'COMPLETED')}
                  className="btn btn-gray-de height-40 btn-green"
                >
                  <span>Completed</span>
                </button>
              </div>
            ) : null}

            {showReschedulebtn ? <>
              <div className="col-auto">
                <a
                  href={`${process.env.REACT_APP_APP_BASE_URL}/alumni/${id}/bas`}
                  className="btn btn-gray-de height-40 btn-green"
                >
                  <span>Reschedule</span>
                </a>
              </div>

              <div className="col-auto">
                <a
                  href={`${process.env.REACT_APP_APP_BASE_URL}/alumni/${id}/bas`}
                  className="btn btn-gray-de height-40 btn-green"
                >
                  <span>Cancel</span>
                </a>
              </div>
            </> : null}


          {shouldShowMissedButton ? (
            <div className="col-auto">
              <button
                onClick={() => handleStatusUpdate(userdata.id, 'MISSED')}
                className="btn btn-gray-de height-40"
              >
                Missed
              </button>
            </div>
          ) : null}

              {(userdata?.counselling_status === 'COMPLETED') && (
                <div className="col-auto">
                  <SendMessage basid={userdata.id} className="btn btn-gray-de height-40 btn-green" btnText="SD" />
                </div>
              )}

              <div className="col-auto">
                <Link
                  to={`/alumni/${id}/profile/counselling-logs`}
                  className="btn btn-gray-de height-40 nav-link btn-darkblue"
                >
                  <span>View Summary</span>
                </Link>
              </div>
            </div>
          </td>
        </tr>
      );
    })
  )}
</tbody>



                                    </table>

                                </div>
                            </div>                                           
                        </div>
                    </div>
                </div>
                

                

            </div>
            
        </div>
        
    </>
  )
}

export default CounsellingSessions;